export const USER_NAME_MIN_LENGTH = 3;
export const USER_NAME_MAX_LENGTH = 24;

const USER_NAME_PATTERN = /^[a-z0-9_.-]{3,24}$/;
const EMAIL_PATTERN = /^[a-z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?(?:\.[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?)+$/i;
const NON_USER_NAME_CHARS = /[^a-z0-9_.-]/g;

export type UserNameValidationError = "empty" | "too_short" | "too_long" | "invalid_chars";

export function normaliseUserName(value: string): string {
    return value.trim().toLowerCase();
}

export function getUserNameValidationError(value: string): UserNameValidationError | null {
    const userName = normaliseUserName(value);
    if (!userName) return "empty";
    if (userName.length < USER_NAME_MIN_LENGTH) return "too_short";
    if (userName.length > USER_NAME_MAX_LENGTH) return "too_long";
    if (!USER_NAME_PATTERN.test(userName)) return "invalid_chars";
    return null;
}

export function isValidUserName(value: string): boolean {
    return getUserNameValidationError(value) === null;
}

export function toUserNameSuggestion(value: string | null | undefined): string {
    return normaliseUserName(value ?? "").replace(NON_USER_NAME_CHARS, "").slice(0, USER_NAME_MAX_LENGTH);
}

export function userNameSuggestionFromEmail(email: string | null | undefined): string {
    return toUserNameSuggestion(email?.split("@")[0] ?? "");
}

export function normaliseSignupUserNameInput(value: string): string {
    const trimmed = value.trim();
    if (EMAIL_PATTERN.test(trimmed)) {
        return userNameSuggestionFromEmail(trimmed);
    }
    return value.toLowerCase();
}

export function isEmailAddress(value: string): boolean {
    const email = value.trim();
    return email.length <= 254 && EMAIL_PATTERN.test(email);
}
